import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => ({
  cardRoot: {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2, 0),
  },

  cImageContainer: {
    flexGrow: 1,
    width: '100%',
    paddingBottom: '100%',
    borderRadius: theme.spacing(0.5),
    backgroundImage: ({ image }) => image && `url(${image})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    overflow: 'hidden',
    border: `1px solid ${theme.palette.primary.main}`,
  },
}));
